import React, { Component } from "react";
import { compose } from 'redux'
import classNames from 'classnames';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { Row, Col, PanelGroup, Panel, Button} from 'react-bootstrap';
import { withRouter } from 'react-router'
import _, { map } from 'lodash'
import {SortableContainer, SortableElement} from 'react-sortable-hoc';

import AdminEditor from "./AdminEditor";
import { serviceTypeMap } from "./constants";
import './AdminDashboard.css';

const SortableItem = SortableElement(({projectKey, value, classes, onClick}) => {
  return (
    <div className={classes + " list-group-item"} key={projectKey} onClick={onClick}>
      {value.name || "Untitled"}
    </div>
  )
});

const SortableList = SortableContainer(({projects, projectKey, serviceType, onSelectProject, onAddProject}) => {
  if (!projects) {
    return <div />
  }
  return (
    <div>
      {
        Object.keys(projects)
        .filter(key => projects[key].serviceType === serviceType)
        .sort((a, b) => projects[a].index - projects[b].index)
        .map((key, index) => {
          let classes = classNames({
            'active': ( key===projectKey )
          });
          return <SortableItem key={key}
                               index={projects[key].index}
                               projectKey={key}
                               value={projects[key]}
                               classes={classes}
                               onClick={() => onSelectProject(key)} />
        })
      }
      <Button bsStyle="info" className="new-project" onClick={onAddProject}>Add New Project</Button>
    </div>
  )
});

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.onSelectService = this.onSelectService.bind(this);
    this.onSelectProject = this.onSelectProject.bind(this);
    this.onAddProject = this.onAddProject.bind(this);
    this.state = {
      serviceType: 'staging',
      projectCount: 0,
      projectKey: props.match.params.projectkey || null,
      project: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.projectKey) {
      return
    }
    if (_.isEqual(nextProps.projects, this.props.projects)) {
      return
    }
    // Project is deleted
    let projectKey = this.state.projectKey
    let project = nextProps.projects[projectKey]
    if (!project) {
      projectKey =
        Object.keys(nextProps.projects)
              .filter(key => {
                return nextProps.projects[key].serviceType === this.state.serviceType
                  && nextProps.projects[key].index === 0 
                })[0]
      project = nextProps.projects[projectKey]
      if (!project) {
        this.props.history.push(`/admin`)
      }
    }

    this.setState({
      serviceType: project ? project.serviceType : "staging",
      project,
      projectKey, 
      projectCount: Object.values(nextProps.projects).filter(value => value.serviceType===this.state.serviceType).length
    });
  }

  onSelectService(serviceType) {
    this.setState({
      serviceType,
      projectCount: Object.values(this.props.projects).filter(value => value.serviceType===serviceType).length
    });
  }

  onSelectProject(projectKey) {
    this.props.history.push(`/admin/${projectKey}`)
    this.setState({
      projectKey,
      project: this.props.projects[projectKey]
    })
  }

  onAddProject() {
    this.props.firebase.push(
      'projects', {
        name: "",
        city: "",
        serviceType: this.state.serviceType,
        index: this.state.projectCount
      }
    )
    .then((snapshot) => {
      let projectKey = snapshot.key
      this.props.history.push(`/admin/${projectKey}`)
      this.setState({
        projectKey,
        project: this.props.projects[projectKey]
      })
    })
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    console.log(oldIndex, newIndex, this.state.serviceType)
    let updates = {};
    map(this.props.projects, (project, key) => {
      if (project.serviceType !== this.state.serviceType) {
        return;
      }
      if (project.index === oldIndex) {
        updates[`/projects/${key}`] = Object.assign({}, project, {index: newIndex})
      }
      if (project.index === newIndex) {
        updates[`/projects/${key}`] = Object.assign({}, project, {index: oldIndex})
      }
    })
    console.log(updates)
    this.props.firebase.ref().update(updates)
  };

  render() {
    return (
      <Row>
        <Col xs={12} md={3}>
          <PanelGroup
            accordion
            id="projects-panel-group"
            activeKey={this.state.serviceType}
            onSelect={this.onSelectService}
          >
            {
              Object.keys(serviceTypeMap).map((serviceType) => {
                return (
                  <Panel eventKey={serviceType} key={serviceType}>
                    <Panel.Heading>
                      <Panel.Title toggle>{serviceTypeMap[serviceType]}</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible>
                      <SortableList axis="y" distance={5} 
                                    projects={this.props.projects}
                                    projectKey={this.state.projectKey}
                                    serviceType={this.state.serviceType}
                                    onSelectProject={this.onSelectProject}
                                    onAddProject={this.onAddProject}
                                    onSortEnd={this.onSortEnd} />
                    </Panel.Body>
                  </Panel>
                );
              })
            }
          </PanelGroup>
        </Col>
        <Col xs={12} md={8}>
          <AdminEditor projectKey={this.state.projectKey} project={this.state.project}/>
        </Col>
      </Row>
    );
  }
}

export default compose(
  firebaseConnect(['projects']),
  withRouter,
  connect(
    ({firebase}) => ({
      projects: firebase.data.projects
    })
  )
)(AdminDashboard)


// WEBPACK FOOTER //
// ./src/AdminDashboard.js